module.exports = __webpack_public_path__ + "img/arrow-down.3e1fe7d6.svg";